import { Component, OnInit, ElementRef, AfterContentInit, ViewChildren, QueryList, AfterViewInit, HostListener, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { Month, Day } from './models/month';
import { CalendarEvent, InternalCalendarEvent } from './models/calendar-event';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { LayoutService } from '../../../shared/layout/layout.service';

@Component({
  selector: 'cierant-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CierantCalendarComponent implements OnInit, AfterContentInit, AfterViewInit, OnChanges {
  @Input() viewStart: Date;
  @Input() viewEnd: Date;
  @Input() loading: boolean;
  @Input() hideDays: boolean;
  @Input() showDecisionModal: boolean;
  @Input() hideHeader: boolean;
  @Output() showOverlayClicked = new EventEmitter();
  @Output() createNewProgramClicked = new EventEmitter();
  @Output() onEventClicked = new EventEmitter();
  months = new Array<Month>();
  @Input() events = new Array<any>();
  internalEvents = new Array<InternalCalendarEvent>();
  dayWidth: number;
  lastMonthReched = false;
  rows: Array<Array<InternalCalendarEvent>> = [];

  constructor(
    private elem: ElementRef,
    private route: Router,
    private layoutService: LayoutService
  ) { }

  ngOnInit() {
    this.renderCalendar();
  }

  ngOnChanges(changes) {
    console.log(changes);
    this.renderEvents();
  }

  ngAfterViewInit(): void {

  }

  setUpSizes(isLast: boolean) {
    if (isLast && !this.lastMonthReched) {
      this.lastMonthReched = true;
      this.renderEvents();
    }
  }

  ngAfterContentInit(): void {

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.layoutService.updateCalendar.next();
  }

  renderCalendar() {
    let daysInPeriod = 0;
    // this.viewStart = moment('2019/01/01').toDate();
    // this.viewEnd = moment('2019/12/31').toDate();
    this.months = new Array<Month>();
    let currentDay = moment(this.viewStart);
    let count = 1;

    daysInPeriod = moment(this.viewEnd).diff(moment(this.viewStart), 'days') + 1;
    do {
      const day = currentDay.format('DD');
      const month = currentDay.format('MM');

      if (!this.months.find(m => m.numberName === month)) {
        this.months.push({
          numberOfDays: currentDay.daysInMonth(),
          name: currentDay.format('MMM'),
          numberName: month,
          days: new Array<Day>(),
          lines: 0
        });
      }

      this.months.find(m => m.numberName === month).days.push({
        isLastDay: currentDay.format('MM-DD-YYYY') === moment(currentDay).endOf('month').format('MM-DD-YYYY'),
        name: day,
        dateDay: currentDay.toDate()
      });
      currentDay = currentDay.add(1, 'day');
      count++;
    } while (count <= daysInPeriod);
  }

  renderEvents(events?) {
    const calendarwidth = this.elem.nativeElement.offsetWidth;
    const internalEvents = new Array<InternalCalendarEvent>();
    const rows: Array<Array<InternalCalendarEvent>> = [
      []
    ];
    this.rows = [];
    (this.events || events).forEach(e => {
      if (!moment(e.endDate).isBefore(moment(this.viewStart))) {
        // calc left position
        let left = 0;
        let marginRight = 0;
        let dateToCompare = e.beginDate;
        const daysToStart = moment(dateToCompare).diff(this.viewStart, 'days');
        for (let i = 0; i < daysToStart; i++) {
          left += parseFloat(window.getComputedStyle(document.getElementsByClassName("day")[i]).width.replace(/px/, ''));
        }
        const dif = calendarwidth - left;
        if (dif < 200) {
          marginRight = -(200 - dif + 30);
        }

        // get the days
        let days: Array<Day> = [];
        this.months.forEach(m => {
          days = days.concat(m.days);
        });

        // calc width
        let daysInPeriod = 0;
        if (
          moment(e.beginDate).isBefore(moment(this.viewStart)) &&
          moment(e.endDate).isAfter(moment(this.viewStart))
        ) {
          dateToCompare = this.viewStart;
        }
        daysInPeriod = moment(e.endDate).diff(moment(dateToCompare), 'days');

        const index = days.findIndex(d => moment(d.dateDay).format('DD-MM-YYYY') === moment(dateToCompare).format('DD-MM-YYYY'));
        const lastDayIndex = index + daysInPeriod;

        let width = 0;
        for (let i = index; i <= lastDayIndex; i++) {
          const el = document.getElementsByClassName("day")[i];
          if (el) {
            const elComputedStyle = window.getComputedStyle(el);
            width += parseFloat(elComputedStyle.width.replace(/px/, ''));
          }
        }

        let placed = false;
        while (!placed) {
          rows.forEach(row => {
            const conflicts = row.filter(evt =>
              ((moment(evt.beginDate).isSameOrAfter(moment(e.beginDate)) && moment(evt.endDate).isSameOrBefore(moment(e.endDate)) ||
              (moment(evt.beginDate).isSameOrAfter(moment(e.beginDate)) && moment(evt.beginDate).isSameOrBefore(moment(e.endDate))) && moment(evt.endDate).isSameOrAfter(moment(e.endDate)) ||
              (moment(evt.beginDate).isSameOrBefore(moment(e.beginDate)) && moment(e.endDate).isSameOrAfter(moment(evt.beginDate)) && moment(e.endDate).isSameOrBefore(moment(evt.endDate))) ||
              moment(e.beginDate) < moment(evt.beginDate) && moment(e.endDate) > moment(evt.endDate))
              ||
              moment(e.beginDate).isSameOrAfter(moment(evt.beginDate)) && moment(e.endDate).isSameOrBefore(moment(evt.endDate)) ||
              (moment(e.beginDate).isSameOrAfter(moment(evt.beginDate)) && moment(e.beginDate).isSameOrBefore(moment(evt.endDate))) && moment(e.endDate).isSameOrAfter(moment(evt.endDate)) ||
              (moment(e.beginDate).isSameOrBefore(moment(evt.beginDate)) && moment(evt.endDate).isSameOrAfter(moment(e.beginDate)) && moment(evt.endDate).isSameOrBefore(moment(e.endDate))) ||
              moment(evt.beginDate).isBefore(moment(e.beginDate)) && moment(evt.endDate).isAfter(moment(e.endDate)))
            );

            if (conflicts.length == 0) {
              if (!e.placed) {
                row.push({
                  ...e,
                  width,
                  left,
                  placed: true,
                  top,
                  marginRight
                } as InternalCalendarEvent);
                e.placed = true;
              }
              placed = true;
            }
          });
          if (!placed) {
            if (!e.placed) {
              rows.push([
                {
                  ...e,
                  width,
                  left,
                  placed: true,
                  top,
                  marginRight
                } as InternalCalendarEvent
              ]);
              e.placed = true;
            }
            placed = true;
          }
        }
      }
    });
    console.log("rows: ", rows);
    // this.internalEvents = internalEvents;
    this.rows = rows;
  }

  goToCampaignLibrary() {
    this.route.navigateByUrl('/campaign-library');
  }

  showOverlay() {
    this.showOverlayClicked.emit();
  }

  openCreateProgramModal() {
    this.createNewProgramClicked.emit();
  }

  eventMouseOver(ev) {
    const event = this.internalEvents.find(e => e.id == ev.id);
    event.active = true;
  }

  eventMouseOut(ev) {
    const event = this.internalEvents.find(e => e.id == ev.id);
    event.active = false;
  }

  eventClicked(ev) {
    this.onEventClicked.emit(ev);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/cierant-calendar/calendar.component.ts